import { render, staticRenderFns } from "./AuthModal.vue?vue&type=template&id=4b15eced&scoped=true&"
import script from "./AuthModal.vue?vue&type=script&lang=js&"
export * from "./AuthModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthModal.vue?vue&type=style&index=0&id=4b15eced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b15eced",
  null
  
)

component.options.__file = "AuthModal.vue"
export default component.exports